/* @flow */
import { RECEIVE_FOUNDRY_RESPONSE } from '../actions/foundry_response';
import type { Action } from '../actions/types';
import {get} from 'lodash';
import {
  SHOPPING_HOME_CATEGORY_ID,
  SHOPPING_CATEGORY_COLLECTIONS_ID
} from '../constants.js';
import extract from '../utils/extract';

const INITIAL_STATE = {
  isShoppingHome: false,
  isBrandOrRetailerPage: false,
  isShoppingCollectionPageHome: false,
  isShoppingSalePage: false,
  categoryType: null,
  resultCount: 0,
  heroImage: null,
  logoImage: null,
  campaignBrandingImage: null,
  breadcrumbs: null,
  openerImages: [],
  featuredCollectionUrl: null,
  featuredCollectionName: null
};

const BRAND_ATTRIBUTES = [
  'brand_id',
  'brand_name',
  'brand_description',
  'brand_image',
  'brand_thumbnail'
];

const RETAILER_ATTRIBUTES = [
  'retailer_id',
  'retailer_name',
  'retailer_description',
  'retailer_image',
  'retailer_thumbnail',
  'retailer_url'
];

export default (state: ProductListState = INITIAL_STATE, action: Action): ProductListState => {
  switch (action.type) {
    case RECEIVE_FOUNDRY_RESPONSE:
      const heroImage = get(action, 'data.page_data.brand_image', null)
        || get(action, 'data.page_data.retailer_image', null);

      return {
        isShoppingHome:
          get(action, 'data.page_data.category_id') === SHOPPING_HOME_CATEGORY_ID
            && !get(action, 'data.page_data.modifiers.search_query')
            && !get(action, 'data.page_data.modifiers.on_sale'),
        isBrandOrRetailerPage: (get(action, 'data.page_data.brand_id', null) !== null
          || get(action, 'data.page_data.retailer_id', null) !== null),
        isShoppingCollectionPageHome:
          get(action, 'data.page_data.category_id') === SHOPPING_CATEGORY_COLLECTIONS_ID
          && !get(action, 'data.page_data.modifiers.search_query'),
        isShoppingSalePage:
          get(action, 'data.page_data.category_id') === SHOPPING_HOME_CATEGORY_ID
          && !get(action, 'data.page_data.modifiers.search_query')
          && get(action, 'data.page_data.modifiers.on_sale'),
        categoryType: get(action, 'data.page_data.category_type', null),
        categoryId: get(action, 'data.page_data.category_id', null),
        resultCount: get(action, 'data.page_data.result_count', 0),
        heroImage: heroImage,
        logoImage: get(action, 'data.page_data.logo_image_url', null),
        campaignBrandingImage: get(action, 'data.page_data.campaign_branding_image_url', null),
        brand: extract(get(action, 'data.page_data', {}), BRAND_ATTRIBUTES),
        retailer: extract(get(action, 'data.page_data', {}), RETAILER_ATTRIBUTES),
        description: get(action, 'data.page_data.meta_data.meta_description', null),
        breadcrumbs: get(action, 'data.page_data.breadcrumbs', null),
        openerImages: get(action, 'data.page_data.opener_images', []),
        featuredCollectionUrl: get(action, 'data.page_data.featured_collection_url', null),
        featuredCollectionName: get(action, 'data.page_data.featured_collection_name', null)
      };
    default:
      return state;
  }
};

type ProductListState = {
  categoryType: ?string,
  resultCount: number,
  heroImage: ?string,
  logoImage: ?string,
  isShoppingHome: bool,
  isBrandOrRetailerPage: bool,
  isShoppingCollectionPageHome: bool,
  isShoppingSalePage: bool,
  featuredCollectionUrl: ?string,
  featuredCollectionName: ?string,
};
